/**
 * User Helper Functions
 * Utility functions for user role checks and management
 */

import { USER_ROLES, type UserRole } from '@/types/user'

/**
 * Check if user has at least Moderator role
 */
export function isModerator(role: UserRole): boolean {
  return role >= USER_ROLES.MODERATOR
}

/**
 * Check if user has at least Editor role
 */
export function isEditor(role: UserRole): boolean {
  return role >= USER_ROLES.EDITOR
}

/**
 * Check if user has at least Admin role
 */
export function isAdmin(role: UserRole): boolean {
  return role >= USER_ROLES.ADMIN
}

/**
 * Check if user has Owner role
 */
export function isOwner(role: UserRole): boolean {
  return role >= USER_ROLES.OWNER
}

/**
 * Get human-readable role name
 */
export function getRoleName(role: UserRole): string {
  const ROLE_NAMES: Record<UserRole, string> = {
    [USER_ROLES.GUEST]: 'Guest',
    [USER_ROLES.USER]: 'User',
    [USER_ROLES.MODERATOR]: 'Moderator',
    [USER_ROLES.EDITOR]: 'Editor',
    [USER_ROLES.ADMIN]: 'Admin',
    [USER_ROLES.OWNER]: 'Owner',
  }
  return ROLE_NAMES[role] || 'Unknown'
}

/**
 * Check if user has specific role or higher
 */
export function hasMinimumRole(
  userRole: UserRole,
  requiredRole: UserRole
): boolean {
  return userRole >= requiredRole
}
